module.exports = __webpack_public_path__ + "static/thpcsheep1-742a42da7c353bc9af32bec416696cb7.jpeg";